<template>
  <div class="coming-page">
    <APageHead title="오디오북" sub="서비스 준비 중입니다." />

    <div class="coming-page__hero">
      <div class="coming-page__hero-icon">
        <i class="material-icons-round">headphones</i>
      </div>
      <h1 class="coming-page__hero-title">오디오북 서비스</h1>
      <p class="coming-page__hero-tagline">서비스 준비 중입니다</p>
      <p class="coming-page__hero-desc">
        더 나은 오디오북 서비스를 제공하기 위해 준비하고 있습니다.<br />
        곧 만나뵐 수 있도록 최선을 다하겠습니다.
      </p>

      <div class="coming-page__features">
        <div class="coming-page__feature">
          <i class="material-icons-round">auto_stories</i>
          <span>풍부한 콘텐츠</span>
        </div>
        <div class="coming-page__feature">
          <i class="material-icons-round">high_quality</i>
          <span>고품질 음성</span>
        </div>
        <div class="coming-page__feature">
          <i class="material-icons-round">devices</i>
          <span>모든 기기 지원</span>
        </div>
      </div>
    </div>

    <div class="coming-page__cards">
      <ACard>
        <div class="coming-page__card-body">
          <div class="coming-page__card-icon coming-page__card-icon--info">
            <i class="material-icons-round">library_books</i>
          </div>
          <div>
            <h6 class="coming-page__card-title">다양한 장르</h6>
            <p>문학, 자기계발, 비즈니스 등 다양한 장르의 오디오북을 제공할 예정입니다.</p>
          </div>
        </div>
      </ACard>
      <ACard>
        <div class="coming-page__card-body">
          <div class="coming-page__card-icon coming-page__card-icon--ok">
            <i class="material-icons-round">speed</i>
          </div>
          <div>
            <h6 class="coming-page__card-title">재생 속도 조절</h6>
            <p>0.5배속부터 2배속까지 원하는 속도로 청취할 수 있습니다.</p>
          </div>
        </div>
      </ACard>
      <ACard>
        <div class="coming-page__card-body">
          <div class="coming-page__card-icon coming-page__card-icon--warn">
            <i class="material-icons-round">bookmark</i>
          </div>
          <div>
            <h6 class="coming-page__card-title">북마크 기능</h6>
            <p>중요한 부분을 북마크하고 언제든지 다시 들을 수 있습니다.</p>
          </div>
        </div>
      </ACard>
    </div>

    <ACard>
      <template #title>
        <span class="coming-page__sec-title">
          <i class="material-icons-round coming-page__sec-icon">schedule</i>
          준비 일정
        </span>
      </template>
      <ul class="coming-page__timeline">
        <li class="coming-page__timeline-item">
          <i class="material-icons-round coming-page__timeline-marker coming-page__timeline-marker--progress">
            radio_button_checked
          </i>
          <span>오디오북 콘텐츠 확보 및 품질 검수 진행 중</span>
        </li>
        <li class="coming-page__timeline-item">
          <i class="material-icons-round coming-page__timeline-marker coming-page__timeline-marker--progress">
            radio_button_checked
          </i>
          <span>플레이어 기능 개발 및 테스트 진행 중</span>
        </li>
        <li class="coming-page__timeline-item">
          <i class="material-icons-round coming-page__timeline-marker coming-page__timeline-marker--planned">
            schedule
          </i>
          <span>서비스 오픈 예정: 추후 공지</span>
        </li>
      </ul>
    </ACard>
  </div>
</template>

<script>
import APageHead from "@/components/Pineapple/APageHead.vue";
import ACard from "@/components/Pineapple/ACard.vue";

export default {
  name: "ContentsAudiobooks",
  components: { APageHead, ACard },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.coming-page {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__hero {
    text-align: center;
    padding: 56px 28px;
    background: $p-sidebar;
    color: $p-sidebar-tx;
    border-radius: $p-radius-xl;
    background-image: radial-gradient(circle at 30% 20%, rgba(255, 201, 60, 0.08) 0%, transparent 50%);
  }

  &__hero-icon {
    width: 96px;
    height: 96px;
    border-radius: 24px;
    background: $p-point;
    color: $p-ink;
    display: inline-grid;
    place-items: center;
    margin-bottom: 20px;
    border: 3px solid $p-point-deep;
    box-shadow: 0 12px 32px -4px rgba(255, 201, 60, 0.5);

    > i { font-size: 48px; }
  }

  &__hero-title {
    margin: 0 0 8px;
    font-size: 32px;
    font-weight: 900;
    letter-spacing: -0.03em;
    color: $p-point;
  }

  &__hero-tagline {
    margin: 0 0 16px;
    font-size: 16px;
    font-weight: 700;
    color: $p-sidebar-tx;
    opacity: 0.85;
  }

  &__hero-desc {
    margin: 0 auto 28px;
    font-size: 14px;
    line-height: 1.8;
    color: $p-sidebar-mid;
    max-width: 480px;
  }

  &__features {
    display: flex;
    justify-content: center;
    gap: 28px;
    flex-wrap: wrap;
  }

  &__feature {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: $p-sidebar-mid;
    font-size: 12px;

    > i {
      width: 56px;
      height: 56px;
      border-radius: 14px;
      background: rgba(255, 255, 255, 0.08);
      backdrop-filter: blur(8px);
      display: grid;
      place-items: center;
      font-size: 28px !important;
      color: $p-sidebar-tx;
    }
  }

  &__cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    @media (max-width: 992px) { grid-template-columns: 1fr; }
  }

  &__card-body {
    display: flex;
    gap: 14px;
    align-items: flex-start;
  }

  &__card-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: grid;
    place-items: center;
    flex-shrink: 0;

    > i { font-size: 22px !important; }

    &--info { background: $p-info-soft; color: $p-info; }
    &--ok { background: $p-ok-soft; color: $p-ok; }
    &--warn { background: $p-warn-soft; color: $p-warn; }
  }

  &__card-title {
    margin: 0 0 6px;
    font-size: 14px;
    font-weight: 800;
    color: $p-ink;
  }

  p {
    margin: 0;
    color: $p-ink-mid;
    font-size: 12px;
    line-height: 1.6;
  }

  &__sec-title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 800;
    color: $p-ink;
  }

  &__sec-icon {
    color: $p-point-deep;
    font-size: 16px !important;
  }

  &__timeline {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__timeline-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: $p-ink2;
  }

  &__timeline-marker {
    font-size: 16px !important;

    &--progress { color: $p-warn; }
    &--planned { color: $p-info; }
  }
}
</style>
